/*
  import mainCommon from '@/utils/mainCommon'
    mixins: [mainCommon],
*/
import computedCommon from './computedCommon'
import methodCommon from './methodCommon'

export default {
  mixins: [computedCommon, methodCommon],
}


// WEBPACK FOOTER //
// ./src/utils/mainCommon.js